import { render, staticRenderFns } from "./RenderProduct.vue?vue&type=template&id=7da1d8c8&scoped=true"
import script from "./RenderProduct.vue?vue&type=script&lang=js"
export * from "./RenderProduct.vue?vue&type=script&lang=js"
import style0 from "./RenderProduct.vue?vue&type=style&index=0&id=7da1d8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1d8c8",
  null
  
)

export default component.exports